import {Component, NgZone, OnInit} from '@angular/core';
import {Account} from "../../shared/models/account";
import {AngularFireAuth} from "@angular/fire/compat/auth";
import {SessionService} from "../../core/service/session.service";
import {AngularFireFunctions} from "@angular/fire/compat/functions";
import {MessageService} from "../../core/service/message.service";
import {Message} from "../../shared/models/message";
import {SvgIconService} from "../../core/service/svg-icon.service";
import {
  USABLE_STRING_FOR_PASSWORD,
} from "../../shared/constants";
import {CommonService} from "../../core/service/common.service";

@Component({
  selector: 'app-password-update',
  templateUrl: './password-update.component.html',
  styleUrls: ['./password-update.component.scss'],
})
export class PasswordUpdateComponent implements OnInit {

  show = false;
  public account = new Account();
  pass: any = {password: '', confirmpassword: ''};
  menuShow = false;
  showLoading = false;

  usable = USABLE_STRING_FOR_PASSWORD;

  // 追加
  constructor(private auth: AngularFireAuth,
              private sessionService: SessionService,
              private fns: AngularFireFunctions,
              private messageService: MessageService,
              private svgIconService: SvgIconService,
              public commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.svgIconService.registerIcons();
  }

  submitLogin(e: Event): void {
    e.preventDefault();

    const subscription = this.auth.user.subscribe(user => {
      subscription.unsubscribe();
      // loading screen.
      this.showLoading = true;
      user?.updatePassword(this.pass.password)
        .then(() => {
          this.fns.httpsCallable('authentication-authentication-setClaimsPasswordUpdated')('')
            .subscribe(() => {
              const message = new Message();
              message.type = 'info';
              message.message = 'パスワードの更新に成功しました。';
              this.messageService.messageSubject.next(message);
              this.showLoading = false;
              this.sessionService.logout();
              // 自動的にログイン
              this.account.email = user?.email ? user.email : '';
              this.account.password = this.pass.password;
              this.sessionService.loginWithEmailAndPassword(this.account);
            }, (err: any) => {
              console.error(err);
              const message = new Message();
              message.type = 'error';
              message.message = 'パスワードの更新に失敗しました。' + err;
              this.messageService.messageSubject.next(message);
              this.showLoading = false;
            });
        }).catch(err => {
        console.error(err);
        const message = new Message();
        message.type = 'error';
        message.message = 'パスワードの更新に失敗しました。' + err;
        this.messageService.messageSubject.next(message);
        this.showLoading = false;
      });
    });
  }
}
